import React, {useEffect, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Collapse, Form, FormGroup, Row,} from 'reactstrap';

import {
    ARE_YOU_SHURE_MSG,
    ARE_YOU_SHURE_TITLE,
    deleteMsg,
    error,
    LIST,
    NO, NO_DATA_FOUND,
    warning,
    YES
} from "../../../components/i18n/i18n";
import {confirmAlert} from 'react-confirm-alert';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import {
    ButtonClean,
    ButtonSearch,
    ButtonTableDelete,
    ButtonTableEdit, ButtonTableFilter
} from "../../../components/buttons/buttonsActions";
import {showToastCustom} from "../../../components/toast/customToast";
import {confMapsService} from "../../../jwt/_services/configuration/confMapsService";
import {showLoader} from "../../../components/loader/loader";
import Select, {makeAnimated} from "react-select";
import {useForm} from "react-hook-form";
import {udnProvider} from "../../../providers/udnProvider";
import {SelectPlatformWithIcon} from "../../../components/select/selectPlatformWithIcon";


export default function ConfMapsList(props) {

    const [fbDataBaseId] = useState(props?.app?.fbDataBase?.id);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [totalSize, setTotalSize] = useState(10);
    const [listItems, setListItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [collapsed, setCollapsed] = useState(true);
    const [udnsOptions, setUdnsOptions] = useState([]);
    const [udn, setUdn] = useState(null);
    const [platform, setPlatform] = useState(null);
    const [dataFilter, setDataFilter] = useState({
        fbDataBase : {  id : fbDataBaseId },
        item : {
            platform: null,
            udn: null
        }
    });
    const animatedComponents = makeAnimated();

    useEffect(() => {
        setLoading(true);
        udnProvider.getOptions()
            .then(result => {
                setUdnsOptions(result);
            })
            .catch(_ => {
                setLoading(false);
            });
        refreshDataList(page, currentIndex, sizePerPage, dataFilter);
    }, []);

    const handleTableChange = (type, {page, sizePerPage}) => {
        let index = (page - 1) * sizePerPage
        refreshDataList(page, index, sizePerPage, dataFilter);
    };

    const refreshDataList = (page, currentIndex, sizePerPage, _dataFilter) => {
        setLoading(true);

        confMapsService.search(currentIndex, sizePerPage, _dataFilter)
            .then(result => {
                if (result){
                    setListItems(result.data);
                    setTotalSize(result.total);
                    setCurrentIndex(currentIndex);
                    setPage(page);
                    setSizePerPage(sizePerPage);
                } else {
                    setListItems([]);
                    setTotalSize(0);
                    setCurrentIndex(0);
                    setPage(1);
                    setSizePerPage(10);
                }
                setLoading(false);
            })
            .catch(errorMessage => {
                setLoading(false);
                setListItems([]);
                setTotalSize(0);
                setCurrentIndex(1);
                setPage(1);
                setSizePerPage(10);
                showToastCustom(error, errorMessage);
            });
    }

    const confirmDelete = (data) => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{ARE_YOU_SHURE_MSG}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            deleteItem(data)
                            onClose();
                        }}>
                            {YES}
                        </button>
                    </div>
                );
            }
        });
    };

    const deleteItem = (data) => {
        setLoading(true);
        confMapsService.deleteItem(data.id)
            .then(_ => {
                setLoading(false);
                setListItems(listItems.filter(register => register.id !== data.id));
                showToastCustom(warning, deleteMsg, true);
            });
    }

    const editItem = (data) => {
        const itemToEdit = listItems.find(n => n.id === data.id);
        props.setForm(true, itemToEdit, "FORM");
    }

    const showFilters = () => {
        setCollapsed(!collapsed);
    }

    //********* Column Formatters *****************
    const actionsFormatter = (cell, row) => {
        return (
            <div className="float-left">
                <ButtonTableDelete onClick={() => confirmDelete(row)}/>
                <ButtonTableEdit onClick={() => editItem(row)}/>
            </div>
        );
    }

    // ----------------------------------------------
    //            SEARCH FILTERS FORM
    // ----------------------------------------------
    const changeSelect = (value) => {
        setUdn(value);
    }

    const changePlatform = (value) => {
        setPlatform(value.value);
    }

    const cleanFields = () => {
        setTotalSize(0);
        setCurrentIndex(1);
        setPage(1);
        reset();
        setUdn(null);
        setPlatform(null);
        const dataRequest = {
            platform: null,
            udn: null
        };
        setDataFilter(dataRequest);
        refreshDataList(page, currentIndex, sizePerPage, dataRequest);
    }

    const {register, handleSubmit, reset} = useForm({});

    const onSubmit = (data, _) => {
        setLoading(true);
        const dataRequest = {};

        if (udn !== undefined && udn !== null)
            dataRequest.udn = { id : udn.id };

        if (platform !== undefined && platform !== null)
            dataRequest.platform = platform;

        setDataFilter(dataRequest);
        refreshDataList(page, currentIndex, sizePerPage, dataRequest);
    };

    const columns = [{
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
        hidden: true
    }, {
        dataField: 'platform',
        text: 'Plataforma',
        sort: true
    }, {
        dataField: 'udnName',
        text: 'UDN'
    }, {
        dataField: 'defaultZoom',
        text: 'Zoom Inicial'
    }, {
        dataField: 'minZoom',
        text: 'Zoom Mínimo'
    }, {
        dataField: 'maxZoom',
        text: 'Zoom Máximo'
    }, {
        dataField: 'imgOverlay',
        text: 'Overlay'
    }, {
        isDummyField: true,
        text: 'Acción',
        formatter: actionsFormatter
    }
    ];

    return (
        <div>
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-list-alt mr-2"> </i>{LIST}
                    <div className="float-right">
                        <ButtonTableFilter onClick={() => showFilters()} collapsed={collapsed}/>
                    </div>
                </CardTitle>
                <Collapse isOpen={collapsed}>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <CardBody className="">
                            <Row>
                                <Col md="4">
                                    <FormGroup>
                                        <Select name="udn"
                                                value={udn}
                                                options={udnsOptions}
                                                components={animatedComponents}
                                                placeholder="Selecciona una unidad negocio"
                                                isSearchable={true}
                                                isClearable={true}
                                                onChange={changeSelect}/>
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <SelectPlatformWithIcon name="platform"
                                                            innerRef={register}
                                                            ref={register}
                                                            value={platform}
                                                            onChange={changePlatform}/>
                                </Col>
                                <Col md="4">
                                    <div className="float-right d-flex justify-content-lg-end">
                                        <ButtonSearch/>
                                        <ButtonClean onClick={() => cleanFields()}/>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Form>

                </Collapse>
                <CardBody className="">
                    {loading ? showLoader() :
                            <BootstrapTable
                                striped hover
                                tableHeaderClass='mb-0'
                                remote
                                keyField="id"
                                data={listItems}
                                columns={columns}
                                noDataIndication={NO_DATA_FOUND}
                                pagination={paginationFactory({page, sizePerPage, totalSize})}
                                onTableChange={handleTableChange}
                            />
                    }
                </CardBody>
            </Card>
        </div>
    )
}
